export default {"src":"/_next/static/media/ic-rename.c8a4fc30.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};